// extracted by css-extract-rspack-plugin
export default {"root":"jS0feH","title":"NbURAz","discount-row":"UhIcqb","discountRow":"UhIcqb"};